<template>
  <div  :style='{width: panelWidth}' >

      <el-table ref='bookaggtable' :data='tableData' class='riskTable' :height="panelHeight" style='width: 100%' fit
          :cell-class-name = "() => 'lu-click'"
          :row-class-name="tableRowClassName"
          @row-dblclick='(row,column) => getDetail(row.instrumentName,row,column)'
          @sort-change='sortChange'
       >
        <el-table-column prop='instrumentName' ref='col1' sortable='custom' :dataKeys="['instrumentName']" sortFieldFormat="String" />
        <el-table-column align='center' :label="getCurrentBookLabel">
          <el-table-column align='center' v-for='book in bookList' :key='book' :label='book' ref='col2' sortable='custom' :dataKeys="['book',book]" sortFieldFormat="Number">
            <template slot-scope="data">
              <div style='text-align: right' :class='cellClass(data.row.book[book])'>{{ data.row.book[book] | formatAmount(bookPnLMode) }}</div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>

      <el-drawer :append-to-body="true" ref="bookConfigDrawer" :title="$t('Book Config')" :visible.sync="showDialog" direction="rtl" size="80%" destroy-on-close :before-close="handleClose" :modal="false">
        <div class="handle-button-close" @click='closeDialog'>
          <i class="el-icon-close" />
        </div>
        <book-config activeTab="books" />
      </el-drawer>

  </div>
</template>

<script>
import elDragDialog from '@/directive/el-dragDialog'
import BookConfig from './components/bookConfig'
import utils from '@/utils/formatNumber'
import { timestamp } from '@/utils'
import monitoringMixin from './mixins'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'BookAggregation',
  directives: { elDragDialog },
  props: [ 'data', 'panel' ],
  mixins: [ monitoringMixin ],
  components: { BookConfig },
  filters: {
    formatAmount (value, bookPnLMode) {
      if (!value) {
        return utils.formatAmount(0, 2, 3, bookPnLMode)
      }
      return utils.formatAmount(value, 2, 3, bookPnLMode)
    }
  },
  data: function () {
    return {
      showDialog: false,
      bookList: [],
      tableData: [],
      currentFilter: { },
      count: 0
    }
  },
  watch: {
    data: {
      handler (value) {
        this.updateData(value)
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters([ 'theme' ]),
    ...mapState({ includeMarkupsVal: state => state.settingsMonitor.settingParams.includeMarkups, panelConfig: state => state.settingsMonitor.settingParams.panelConfig }),
    excelColumns () {
      let columns = []
      for (let i = 0; i < 26; i++) {
        columns.push(String.fromCharCode(0x41 + i))
      }
      for (let i = 0; i < 26; i++) {
        for (let j = 0; j < 26; j++) {
          columns.push(String.fromCharCode(0x41 + i) + String.fromCharCode(0x41 + j))
        }
      }
      return columns
    },
    bookPnLMode: function () {
      let tmp = this.panelConfig.find(item => item.id === this.panel.id)
      return tmp ? tmp.options.bookPnLMode : 0
    },
    getCurrentBookLabel() {
      return this.getBookLabel(this.bookPnLMode)
    },
    getLotsMios: function () {
      let tmp = this.panelConfig.find(item => item.id === this.panel.id)
      return !!tmp.options.lotsMios && tmp.options.lotsMios === 'lots' ? 'lots' : 'mios'
    },
    styleTooltip: function () {
      return this.theme !== 'light-theme' ? 'dark' : 'light'
    }
  },
  methods: {
    sortChange: function(data) {
      const { column, order } = data

      // let currentCol = this.getColumns().find(item => item.columnId === column.id)
      let currentCol = this.getColumn(column.id)

      let dataKeys = []
      let sortFieldFormat = ""
      if (currentCol && currentCol.hasOwnProperty('$attrs')) {
        dataKeys = currentCol.$attrs.dataKeys
        sortFieldFormat = currentCol.$attrs.sortFieldFormat
      }

      this.currentFilter = { dataKeys, sortFieldFormat, order }
      this.dataSort()
    },
    getColumn: function(columnId) {
      return this.getColumns().find(item => item.columnId === columnId)
    },
    getColumns: function() {
      let columns = []
      for (let ref of ["col1", "col2"]) {
        if (this.$refs[ref]!==null && this.$refs[ref]!==undefined) {
          if (Array.isArray(this.$refs[ref])) {
            columns = columns.concat(this.$refs[ref])
          } else {
            columns.push(this.$refs[ref])
          }
        }
      }
      return columns
    },
    dataSort: function() {
      let { dataKeys, sortFieldFormat, order } = this.currentFilter
      if (!(Boolean(dataKeys) && Boolean(order))) {
        // default
        dataKeys = ['index']
        sortFieldFormat = 'Number'
        order = 'ascending'
        this.currentFilter = { dataKeys, sortFieldFormat, order }
      }
      this.tableData.sort(this.sortBy(dataKeys,sortFieldFormat,order))
    },
    sortBy: function(dataKeys,sortFieldFormat,order) {
      return function(a,b) {
        let value = 0

        const getPropValue = (data,dataKeys,sortFieldFormat) => {
          let currentData = data
          for (let key of dataKeys) {
            if (currentData!==null && currentData!==undefined && currentData.hasOwnProperty(key)) {
              currentData = currentData[key]
            }
          }
          if (typeof currentData === "object") {
            if (sortFieldFormat === 'String') {
              currentData = ''
            } else if (sortFieldFormat === 'Number') {
              currentData = 0
            } else {
              currentData = 0
            }
          }

          //format
          if (sortFieldFormat === 'String') {
            value = currentData.toUpperCase() 
          } else if (sortFieldFormat === 'Number') {
            if (!currentData) {
              currentData = 0
            }
            value = Math.abs(parseFloat(currentData))
          }
          return value
        }

        let valueA = getPropValue(a,dataKeys,sortFieldFormat)
        let valueB = getPropValue(b,dataKeys,sortFieldFormat)

        // //ref
        if (a.instrumentName==='Instrument') {
          return -1
        }
        if (b.instrumentName==='Instrument') {
          return 1
        }

        if (valueA>valueB) {
          // return 1
          return order==='ascending' ? 1 : -1
        }
        else if (valueA<valueB) {
          // return  -1
          return order==='ascending' ? -1 : 1
        }

        return 0
      }
    },
    updateData(value) {
      let data = this.parseData(value)
      this.bookList = data.bookList
      this.tableData = data.tableData
      this.dataSort()
      this.updateLayout()
    },
    updateLayout() {
      if (this.$refs.bookaggtable && this.$refs.bookaggtable.doLayout) {
          this.$refs.bookaggtable.doLayout()
      }
    },
    getBookLabel(bookPnLMode) {
      if (bookPnLMode) {
        return this.$t('Book Position')
      } else {
        return this.$t('Book PnL')
      }
    },
    getDataField(bookPnLMode) {
      if (bookPnLMode) {
        if (this.getLotsMios === 'lots') {
          return 'numberOfLot'
        } else {
          return 'exposure'
        }
      } else {
        return 'profitAndLoss' 
      }
    },
    getExcelSheetName(bookPnLMode) {
      if (bookPnLMode) {
        return this.$t('Book Aggregation Exposure')
      } else {
        return this.$t('Book Aggregation PnL')
      }
    },
    parseData (value, bookPnLMode = this.bookPnLMode) {
      // let stpBrokerList = []
      let bookList = []
      // let categoryList = []
      let tableData = []
      let bookHash = {}
      this.count++
      let index = 0

      value.forEach(broker => {
        let row = {
          instrumentName: broker.instrumentName,
          label: broker.label,
          book: {}
        }
        if (broker.dossierList && broker.dossierList.length) {
          broker.dossierList.forEach(dossier => {
            if (!bookHash[dossier.dosName]) {
              bookHash[dossier.dosName] = bookList.length + 1
              bookList.push(dossier.dosName)
            }
            let fieldName = this.getDataField(bookPnLMode)
            if (dossier.hasOwnProperty(fieldName)) {
              row.book[dossier.dosName] = dossier[fieldName]
            } else {
              row.book[dossier.dosName] = "0.00"
            }
          })
        }
        index++
        row.index = index
        tableData.push(row)
      })
      return {
        bookList: bookList,
        tableData: tableData
      }
    },
    onSettings () {
      this.showDialog = !this.showDialog
    },
    onChangeBookPnLMode () {
      this.updateData(this.data)
    },
    onChangeLotsMios () {
      this.updateData(this.data)
    },
    handleClose(done) {
      this.showDialog = false
      setTimeout(() => {
        done();
        // animation takes time
        setTimeout(() => {
        }, 400);
      }, 600);
    },
    closeDialog () {
      if (this.$refs.bookConfigDrawer)
        this.$refs.bookConfigDrawer.closeDrawer()
    },
    cellClass (value) {
      return value < 0 ? 'negative' : 'positive'
    },
    handleDownload (dataList, sheetOnly) {
      return import('@/vendor/Export2Excel').then(excel => {
        let sheetList = []
        const columns = this.excelColumns

        for (let bookPnLMode of [0,1]) {
          let data = this.parseData(dataList,bookPnLMode)

          let headers = [
            [ '' ],
            [ '' ],
          ]

          let merges = [ 'A1:A2' ]

          let col = 1

          let start = col

          // Book
          data.bookList.forEach(b => {
            headers[0].push(this.getBookLabel(bookPnLMode))
            headers[1].push(b)
          })

          col += data.bookList.length
          if (start < col) {
            merges.push(columns[start] + '1:' + columns[col - 1] + '1')
          }

          let tableData = []
          data.tableData.forEach(row => {
            let thisRow = []
            thisRow.push(row.instrumentName)
            data.bookList.forEach(b => {
              if (row.book[b]) {
                thisRow.push(row.book[b])
              }
              else {
                thisRow.push('0.00')
              }
            })

            tableData.push(thisRow)
          })

          sheetList.push({
            multiHeader: headers,
            data: tableData,
            merges: merges,
            sheetName: this.getExcelSheetName(bookPnLMode)
          })
        }

        if (sheetOnly) {
          // return sheetList
          return {
            isMultiTab: true,
            tabList: sheetList
          }
        } else {
          let filename = this.panel.exportExcelFilePrefix + '_' +  timestamp()

          excel.export_json_to_excel_lusis_multisheet({
            filename: filename,
            autoWidth: true,
            bookType: 'xlsx',
            sheets: sheetList
          })
        }
      })
    },
    getDetail: function (label,row,column) {
      let currentCol = this.getColumn(column.id)
      let dataKeys = []
      let platform = ""
      let bookName = ""
      if (currentCol && currentCol.hasOwnProperty('$attrs')) {
        dataKeys = currentCol.$attrs.dataKeys
      }
    
      if (dataKeys!==null && dataKeys!==undefined) {
        if (dataKeys[0] === 'book' && dataKeys.length>=3) {
          platform = dataKeys[1]
          bookName = dataKeys[2]
        }
      }

      let params = [
        {'paramName': 'origin', 'paramValue': this.panel.id},
        {'paramName': 'symbol', 'paramValue': label}
      ]
      this.$emit('getDetail', {title: this.panel.options.title, type: 'symbol', value: label, params: params, show: true, platform: platform, bookName: bookName})
    }
  }
}
</script>

<style lang='scss'>
.el-drawer.rtl {
  overflow: visible;
  animation: none !important;
}

.handle-button-close {
  width: 48px;
  height: 48px;
  position: absolute;
  opacity: .8;
  top: 50%;
  left: -48px;
  transform: translateY(-50%);
  text-align: center;
  font-size: 24px;
  border-radius: 6px 0 0 6px !important;
  z-index: 1111110;
  pointer-events: auto;
  cursor: pointer;
  line-height: 48px;
  i {
    font-size: 24px;
    line-height: 48px;
  }
}

.tooltip {
      padding: 3px;
  }

  .tooltip .itemTitle{
    padding: 3px;
  }

  .tooltip  .itemValue{
    padding: 3px;
    text-align: right;
    justify-content:  flex-end;
  }
</style>